import {
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Divider,
} from "@mui/material";

const SingleOption = ({ title, icon, onClick }) => (
  <>
    <ListItem disablePadding onClick={onClick && onClick}>
      <ListItemButton>
        <ListItemIcon>{icon}</ListItemIcon>
        <ListItemText primary={title} sx={{ color: "#fff" }} />
      </ListItemButton>
    </ListItem>
    <Divider />
  </>
);

export default SingleOption;
